import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
    FaTachometerAlt,
    FaPlusCircle,
    FaHandHoldingUsd,
    FaCog,
    FaSignOutAlt,
    FaFile,
    FaUsers,
    FaRupeeSign,
} from "react-icons/fa";
import "./header.css";

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState(null);
    const [orgLogo, setOrgLogo] = useState(null);

   
    

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        const storedLogo = localStorage.getItem("orgLogo");

        if (!storedUser) {
            navigate("/", { replace: true });
            return;
        }

        setUser(storedUser);

        if (storedLogo) {
            setOrgLogo(storedLogo);
        } else {
            fetchOrganizationLogo(storedUser.org_id);
        }
    }, [navigate]);


    const fetchOrganizationLogo = async (orgId) => {
        if (!orgId) return;

        try {
            const res = await fetch("http://localhost:5000/api/org");
            const data = await res.json();

            if (Array.isArray(data)) {
                const matchedOrg = data.find((org) => org.org_id === orgId);

                if (matchedOrg?.logo) {
                    setOrgLogo(matchedOrg.logo); // ✅ FIXED
                    localStorage.setItem("orgLogo", matchedOrg.logo);
                }
            }
        } catch (err) {
            console.error("Error fetching organization:", err);
        }
    };


    const isActive = (path) => location.pathname.startsWith(path);

    const handleLogout = async () => {
        if (!window.confirm("Are you sure you want to logout?")) return;

        const showPopup = localStorage.getItem("showDashboardPopup");
        const userId = localStorage.getItem("user_id");

        if (showPopup === "true" && userId) {
            try {
                await fetch("http://localhost:5000/api/complete-first-login", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ user_id: userId }),
                });
            } catch (err) {
                console.error("Logout update failed:", err);
            }
        }

        localStorage.clear();
        navigate("/", { replace: true });
    };


    return (
        <div className="layout-container">
            <div className="sidebar">
                <br />
                <br />

                {/* LOGO */}
                <div className="sidebar-logo">
                    {orgLogo && orgLogo.trim() !== "" ? (
                        <img
                            src={orgLogo}
                            alt="Org Logo"
                            style={{
                                width: "150px",
                                height: "70px",
                                borderRadius: "10px",
                                objectFit: "contain",
                                backgroundColor: "#fff",
                                padding: "5px",
                            }}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = "/no-logo.png";
                            }}
                        />
                    ) : (
                        <h3>I-Pro</h3>
                    )}
                </div>


                <nav className="sidebar-nav">
                    {user?.role === "superadmin" && (
                        <button
                            className={isActive("/create-organzation") ? "active" : ""}
                            onClick={() => navigate("/create-organzation")}
                        >
                            <FaCog /> Manage Organization
                        </button>
                    )}

                    {user?.role === "admin" && (
                        <>
                            <button
                                className={isActive("/hr-dashboard") ? "active" : ""}
                                onClick={() => navigate("/hr-dashboard")}
                            >
                                <FaTachometerAlt /> Dashboard
                            </button>

                            <button
                                className={isActive("/policy-list") ? "active" : ""}
                                onClick={() => navigate("/policy-list")}
                            >
                                <FaFile /> Manage Policy
                            </button>

                            <button
                                className={isActive("/initial-setup") ? "active" : ""}
                                onClick={() => navigate("/initial-setup")}
                            >
                                <FaPlusCircle /> Manage Scheme
                            </button>

                            <button
                                className={isActive("/manage-employee") ? "active" : ""}
                                onClick={() => navigate("/manage-employee")}
                            >
                                <FaUsers /> Manage Employee
                            </button>

                            <button
                                className={isActive("/claimstatus") ? "active" : ""}
                                onClick={() => navigate("/claimstatus")}
                            >
                                <FaHandHoldingUsd /> Manage Claim
                            </button>

                            <button
                                className={isActive("/cd-balance") ? "active" : ""}
                                onClick={() => navigate("/cd-balance")}
                            >
                                <FaRupeeSign /> Check CD Balance
                            </button>

                            <button
                                className={isActive("/organization") ? "active" : ""}
                                onClick={() => navigate("/organization")}
                            >
                                <FaCog /> Settings
                            </button>
                        </>
                    )}

                    {user?.role === "user" && (
                        <>
                            <button
                                className={isActive("/employeeprofile") ? "active" : ""}
                                onClick={() => navigate("/employeeprofile")}
                            >
                                <FaTachometerAlt /> Dashboard
                            </button>

                            <button
                                className={isActive("/claimRequest") ? "active" : ""}
                                onClick={() => navigate("/claimRequest")}
                            >
                                <FaHandHoldingUsd /> Claim Request
                            </button>
                        </>
                    )}


                    <button onClick={handleLogout}>
                        <FaSignOutAlt /> Logout
                    </button>
                </nav>
            </div>

            <div className="main-wrapper">
                <div className="top-right">
                    {user ? (
                        <>
                            <p>
                                Welcome, <strong>{user.user_name}</strong>
                            </p>
                            <span>Role: {user.role || "N/A"}</span>
                        </>
                    ) : (
                        <p>Loading user...</p>
                    )}
                </div>

                <div className="page-content">{/* CHILD PAGES HERE */}</div>
            </div>
        </div>
    );
};

export default Header;
